
const isPromotionsPage = (asPath: string) => {
  return asPath.includes('/promotions/');
};

export default isPromotionsPage;
